import { Product } from "../../types/Product";
import { ProductVariant } from "../../types/ProductVariant";
import { formatMoney } from "../../styles/liquidGlass";

interface ProductBasicInfoProps {
  product: Product;
  variant?: ProductVariant | null;
}

export default function ProductBasicInfo({ product, variant }: ProductBasicInfoProps) {
  const displayPrice = variant ? variant.precio : product.precio;

  return (
    <div>
      <h1
        style={{
          fontSize: 44,
          lineHeight: 1,
          margin: 0,
          fontWeight: 500,
          letterSpacing: "-0.035em",
        }}
      >
        {product.nombre}
      </h1>

      <div style={{ marginTop: 22, display: "flex", alignItems: "baseline", gap: 12, flexWrap: "wrap" }}>
        <span className="mono" style={{ fontSize: 38, fontWeight: 600, letterSpacing: "-0.025em" }}>
          {formatMoney(displayPrice)}
        </span>

      </div>
    </div>
  );
}
